export const firstTimeDriverPackages = [
  {
    id: 1,
    title: "Drug and Alcohol course",
    price: "$29.95",
    description:
      "The Drug & Alcohol course is required to get your license. (New Drivers)",
    note: "You must be 18 years or older to register",
    moreInfoLink: "/first-time-driver-course",
    registerLink:
      "https://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=Mzg0",
    columnClass: "col-lg-4 col-md-6",
    isPackage: false,
  },
  {
    id: 2,
    title: "Florida Permit Practice Test",
    price: "$19.95",
    description: "Practice Exam for Florida DMV Permit",
    moreInfoLink: "/prep-course",
    registerLink:
      "https://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=NTE1",
    columnClass: "col-lg-4 col-md-6",
    isPackage: false,
  },
  {
    id: 3,
    title: "Florida Permit Test",
    price: "$80.00",
    description: "DMV In Person Proctored Exam Florida",
    note: "For 18 years and older the test must be taken In person at any of our 4 convenient locations",
    moreInfoLink: "/florida-driving-test",
    viewLocationsLink: "#",
    registerLink:
      "https://classroom.metrotrafficschool.com/dmv-exam-register/MzQ=",
    columnClass: "col-lg-4 col-md-6",
    isPackage: false,
  },
  {
    id: 4,
    title: "Save more Package",
    price: "$89.95",
    description: "Drug & Alcohol course + Florida DMV Permit Exam",
    savings: "SAVE $20.00 - 18%!",
    note: "The DMV Permit test - Proctored (In Person) must be taken at any of our 4 convenient locations - You can register now and walk in - no appointment needed",
    viewLocationsLink: "#",
    registerLink:
      "https://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=MzIzMA==",
    columnClass: "col-lg-6",
    isPackage: true,
  },
  {
    id: 5,
    title: "Complete Package with Practice Exam",
    price: "$99.95",
    description:
      "Drug & Alcohol course + Permit Practice Test + Florida DMV Permit Exam",
    savings: "SAVE $29.95 - 23%!",
    note: "The DMV Permit test - Proctored (In Person) must be taken at any of our 4 convenient locations - You can register now and walk in - no appointment needed",
    viewLocationsLink: "#",
    registerLink:
      "https://courses.metrotrafficschool.com/onlinecourses/registration/create_account?awc_id=MzIzNQ==",
    columnClass: "col-lg-6",
    isPackage: true,
  },
];

export const locations = [
  {
    id: 1,
    name: "HEADQUARTERS AIRPORT/DORAL AREA",
    address: "7500 N.W. 25th Street #119 Miami, FL 33122",
  },
  {
    id: 2,
    name: "WEST DADE/FIU AREA",
    address: "1321 SW 107 Ave #213A Miami, FL 33174",
  },
  {
    id: 3,
    name: "Broward Road Test Location",
    address: "3726 W. Oakland Park Blvd, Lauderdale Lakes, FL 33311",
  },
  {
    id: 4,
    name: "CENTRAL PALM BEACH AREA",
    address: "1993 S. Military Trail West Palm Beach, FL 33415",
  },
];
